import { Flex, Input, SegmentedControl, Text } from '@byecode/ui'
import { DELAY_TYPE, EventConfig } from '@lighthouse/core'
import { ListItem4ByecodeUi } from '@lighthouse/shared'
import React, { useCallback, useMemo } from 'react'
import { useImmer } from 'use-immer'

import { PopoverQuestion } from '@/components/PopoverQuestion'
import { transform2Number } from '@/utils/number'

import { EventDelayOptions } from '../constant'

interface CommonEventConfigProps {
    value: EventConfig | undefined
    onChange: (value: EventConfig) => void
}

export const CommonEventConfig: React.FC<CommonEventConfigProps> = ({ value, onChange }) => {
    const [_value, setValue] = useImmer(value)
    const { delayRunConfig } = _value || {}

    const isShowDelayTime = useMemo(() => {
        return delayRunConfig?.type === DELAY_TYPE.DEBOUNCE || delayRunConfig?.type === DELAY_TYPE.THROTTLE
    }, [delayRunConfig])

    const handleBlur = useCallback(() => {
        onChange({
            ..._value,
            delayRunConfig: {
                type: delayRunConfig?.type ?? DELAY_TYPE.NONE,
                time: delayRunConfig?.time ?? 0
            }
        })
    }, [onChange, _value, delayRunConfig?.type, delayRunConfig?.time])

    const handleChange = useCallback(
        (value: EventConfig) => {
            setValue(value)
            onChange?.(value)
        },
        [onChange, setValue]
    )

    const handleChangeTime = useCallback(
        (ev: React.ChangeEvent<HTMLInputElement>) => {
            const val = ev.target.value
            const num = val ? transform2Number(val) : undefined
            setValue(draft => {
                if (draft && draft.delayRunConfig) {
                    draft.delayRunConfig.time = num
                    return
                }
                return {
                    delayRunConfig: {
                        type: delayRunConfig?.type ?? DELAY_TYPE.NONE,
                        time: num ?? 0
                    }
                }
            })
        },
        [delayRunConfig?.type, setValue]
    )

    return (
        <>
            <ListItem4ByecodeUi justifyContent="space-between" alignItems="center">
                <PopoverQuestion
                    type="delayRunType"
                    position="left-start"
                    arrowOffset={10}
                    mainAxis={12}
                    // position="bottom-start"
                    renderTarget={(node, ref) => (
                        <Flex alignItems="center" gap={4} ref={ref}>
                            <Text>延迟执行</Text> {node}{' '}
                        </Flex>
                    )}
                />

                <SegmentedControl
                    style={{ width: 180 }}
                    data={EventDelayOptions}
                    value={delayRunConfig?.type ?? DELAY_TYPE.NONE}
                    onChange={v => {
                        handleChange({
                            ..._value,
                            delayRunConfig: {
                                type: v as DELAY_TYPE,
                                time: delayRunConfig?.time ?? 0
                            }
                        })
                    }}
                    fullWidth
                />
            </ListItem4ByecodeUi>
            {isShowDelayTime && (
                <ListItem4ByecodeUi justifyContent="space-between" alignItems="center">
                    <Text>延迟时长</Text>
                    <Input
                        style={{ width: 180 }}
                        suffix={<Text>ms</Text>}
                        type="number"
                        value={delayRunConfig?.time ?? 0}
                        onChange={handleChangeTime}
                        onKeyDownCapture={ev => {
                            if (ev.key === 'Enter') {
                                ev.currentTarget.blur()
                            }
                        }}
                        onBlur={handleBlur}
                    />
                </ListItem4ByecodeUi>
            )}
        </>
    )
}
